import { LanguageLink } from '@hilma/netina2all';

import { useTranslateTexts } from '../hooks';
import { siteMap } from '../constants';

const SiteMap: React.FC = () => {
    const alts = useTranslateTexts<string[]>(siteMap.map(item => item.alt));
    const titles = useTranslateTexts<string[]>(siteMap.map(item => item.title));

    return (
        <div id='site-map' >
            <div id='site-map-container' >
                {siteMap.map((item, index) => {
                    return (
                        <div key={index} className='site-map-item' >
                            <LanguageLink to={item.route} >
                                <div className='site-map-img'>
                                    <img height='40%' src={item.imagePath} alt={alts[index]} />
                                </div>
                            </LanguageLink>
                            <div>{titles[index]}</div>
                        </div>
                    )
                })}

            </div>
        </div>
    );
}

export default SiteMap;